import cx from "classnames";

import { ArrowSelectorIcon } from "shared/forms/SelectCombo/ArrowSelectorIcon";
import { useI18n } from "utils/with-i18n.utils";

import { displayModelName } from "./utils";

type Props = {
  slugs: string[];
  setLeftModel: (value: string) => void;
  setRightModel: (value: string) => void;
  leftSlug?: string;
  rightSlug?: string;
  className?: string;
};

export const ModelsSelector = ({
  slugs,
  setLeftModel,
  setRightModel,
  leftSlug,
  rightSlug,
  className,
}: Props) => {
  const i18n = useI18n();

  return (
    <div className="sticky top-0 z-10 py-5 w-full bg-lotion">
      <div
        className={cx(
          "flex  gap-5 sm:gap-10 justify-center items-center py-5 -my-5 w-full mx-auto",
          className,
        )}
      >
        <div className="relative pr-5 w-full bg-white rounded-md border border-black/35">
          <select
            className="p-3 w-full text-sm font-medium text-ellipsis bg-transparent focus:outline-none appearance-none sm:text-base lg:!text-xl"
            value={leftSlug}
            onChange={(event) => setLeftModel(event.target.value)}
          >
            <option value="">{i18n.t("comparator.chooseModel")}</option>

            {slugs
              .filter((slug) => slug !== rightSlug)
              .map((slug) => (
                <option key={slug} value={slug}>
                  {displayModelName(slug)}
                </option>
              ))}
          </select>
          <ArrowSelectorIcon className="absolute top-1/2 right-3 h-auto -translate-y-1/2" />
        </div>
        <p className="hidden py-2 text-xl italic font-black text-center 2xs:block">
          VS
        </p>
        <div className="relative pr-5 w-full bg-white rounded-md border border-black/35">
          <select
            className="p-3 w-full text-sm font-medium text-ellipsis bg-transparent focus:outline-none appearance-none sm:text-base lg:!text-xl"
            value={rightSlug}
            onChange={(event) => setRightModel(event.target.value)}
          >
            <option value="">{i18n.t("comparator.chooseModel")}</option>

            {slugs
              .filter((slug) => slug !== leftSlug)
              .map((slug) => (
                <option key={slug} value={slug}>
                  {displayModelName(slug)}
                </option>
              ))}
          </select>
          <ArrowSelectorIcon className="absolute top-1/2 right-3 h-auto -translate-y-1/2" />
        </div>
      </div>
    </div>
  );
};
